var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5"},[_c('v-card',[_c('GChart',{attrs:{"type":"LineChart","settings":{ packages: ['corechart'] },"data":_vm.DataArray,"options":_vm.chartOptions,"title":_vm.chartOptions.title}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }